const axios = require('axios').default
var globals = require('./globals').globals

var url = globals.SERVER_URL + '/api'

function Reffferal(query) {
  return axios.get(`${url}/users/referral`, { params: query, headers: { authorization: `Bearer ${localStorage.getItem('token')}` } })
}

function login(data) {
  return axios.post(`${url}/auth/signin`, data)
}

function getUsers(query) {
  return axios.get(`${url}/users`, { params: query, headers: { authorization: `Bearer ${localStorage.getItem('token')}` } })
}

function validateUser() {
  return axios.get(`${url}/auth/validate/token`, { headers: { authorization: `Bearer ${localStorage.getItem('token')}` } })
}

function changeUserStatus(body) {
  return axios.post(`${url}/users/status`, body, { headers: { authorization: `Bearer ${localStorage.getItem('token')}` } })
}

function getActivities(query) {
  return axios.get(`${url}/users/activities`, { params: query, headers: { authorization: `Bearer ${localStorage.getItem('token')}` } })
}

function getMatches(query) {
  return axios.get(`${url}/users/matches`, { params: query, headers: { authorization: `Bearer ${localStorage.getItem('token')}` } })
}

function getInterests(query) {
  return axios.get(`${url}/users/interests`, { params: query, headers: { authorization: `Bearer ${localStorage.getItem('token')}` } })
}

function getUserProfile(query) {
  return axios.get(`${url}/users/profile`, { params: query, headers: { authorization: `Bearer ${localStorage.getItem('token')}` } })
}
function updateUserPlan(data) {
  return axios.put(`${url}/users/updatePlan`, data, { headers: { authorization: `Bearer ${localStorage.getItem('token')}` } })

}
function getDashboardData(query) {
  return axios.get(`${url}/users/dashboard`, { params: query, headers: { authorization: `Bearer ${localStorage.getItem('token')}` } })
}

function getOrdersList(query) {
  return axios.get(`${url}/users/orders`, { params: query, headers: { authorization: `Bearer ${localStorage.getItem('token')}` } })
}

function updateLeadStatus(data) {
  return axios.put(`${url}/users/interests`, data, { headers: { authorization: `Bearer ${localStorage.getItem('token')}` } })
}

function deleteUserProfile(data) {
  return axios.delete(`${url}/users`, { headers: { authorization: `Bearer ${localStorage.getItem('token')}` }, params: data })
}

function getAvailablePlans() {
  return axios.get(`${url}/plan/all`, { headers: { authorization: `Bearer ${localStorage.getItem('token')}` } })
}

export {
  login,
  getUsers,
  validateUser,
  changeUserStatus,
  getActivities,
  getMatches,
  getInterests,
  getUserProfile,
  getDashboardData,
  updateUserPlan,
  getOrdersList,
  updateLeadStatus,
  deleteUserProfile,
  Reffferal,
  getAvailablePlans
}
